import Vue from 'vue';

export const ImageHelper = {
    bind(el, binding, vnode) {
        const value = binding.value;
        el.src = `http://util.totalexpert.net/tmb/index.php?src=${el.src}&w=${value}`;
    }
}

Vue.directive('image-helper', ImageHelper);